<template>
    <InputLayout :v="v" :label="label">
        <div class="input-group" :class="{ 'is-invalid': v && v.$error }">
            <div v-if="prependIcon" class="input-group-prepend">
                <span style="border-radius: 5px 0 0 5px;" class="input-group-text" id="basic-addon1"><i class="bi" :class="prependIcon"></i></span>
            </div>
            <input 
                class="form-control" 
                :type="type" 
                :min="min" 
                :max="max"
                :id="v.$path"
                :maxlength="maxlength"
                :class="{ 'is-invalid': v && v.$error }" 
                :value="modelValue" 
                @input="$emit('update:modelValue', $event.target.value)"
                @focus="$emit('onClick')"
                @change="$emit('onChange', $event)"
                v-on="isPreventSubmit ? { keydown: preventSubmit } : {}"
            />
        </div>
    </InputLayout>
</template>

<script>
    import InputLayout from '@/components/InputLayout.vue';

    export default {
        props: {
            label: {
                required: true
            },
            v: {
                required: true,
            },
            modelValue: {
                required: true,
            },
            type: {
                default: 'text',
            },
            min: {
                default: '',
            },
            max: {
                default: '',
            },
            isPreventSubmit: {
                default: false,
            },
            maxlength: {
                default: 255,
            },
            prependIcon: {
              default: false
            },
        },
        components: {            
            InputLayout,
        },
        emits: ['update:modelValue','onClick','onChange'],
        methods: {
            preventSubmit: function(event)
            {
                if(event.key === 'Enter')
                {
                    event.stopPropagation()
                    event.preventDefault();
                }
            }
        }
    }
</script>
